import { initErrorReporting } from "@freightsimple/observability/errorReporting";
import { isProduction } from "../environment";

if (isProduction()) {
  initErrorReporting({
    dsn: "https://0478f034ea171efa8419e4395f18745a@o444510.ingest.us.sentry.io/4511050265526272",
    environment: "production",
    // Expected during the stale token → redirect flow, not a real error.
    ignoreErrors: ["Authentication redirect in progress"],
  });
}
